export const kitchens = [
  {
    slug: "aether-series",
    index: "01",
    name: "Aether Series",
    finish: "PU Finish",
    layout: "Parallel kitchen",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/0h3t1jhk_IMG_6694.jpg",
    alt: "Aether Series kitchen with smooth satin PU cabinetry",
    description: "Aether is a study in quiet precision — a smooth, sprayed polyurethane surface with a soft satin reflection, chosen for colour depth, clean edges and easy everyday care.",
    variants: { cream: "/variants/aether-cream.png", grey: "/variants/aether-grey.png" },
    materials: ["Sprayed PU shutter fronts, satin sheen", "E1-grade, low-emission board core", "European soft-close hardware", "Quartz composite worktop"],
  },
  {
    slug: "noir-luxe",
    index: "02",
    name: "Noir Luxe",
    finish: "Solid Wood",
    layout: "L-shaped kitchen",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/5agxv8k5_IMG_6696.jpg",
    alt: "Noir Luxe kitchen in solid natural timber with visible grain",
    description: "Tactile natural timber with visible grain variation, sealed to protect the surface while preserving the warmth and character of the material.",
    materials: ["Solid timber shutter fronts", "Natural oil-and-wax sealant", "Brass-accented handles", "Honed stone worktop"],
  },
  {
    slug: "celeste-island",
    index: "03",
    name: "Celeste Island",
    finish: "Solid Wood",
    layout: "Island kitchen",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/y2hl4001_IMG_6698.jpg",
    alt: "Celeste Island kitchen crafted in solid natural timber",
    description: "Celeste celebrates honest materiality — solid timber fronts with visible grain and natural warmth, hand-finished and sealed so the surface ages gracefully. Around the island, the wood's quiet texture turns everyday cooking into something tactile and grounded.",
    materials: ["Solid timber shutter fronts", "Hand-finished protective sealant", "Soft-close solid wood drawers", "Natural stone worktop"],
  },
  {
    slug: "vertex",
    index: "04",
    name: "Vertex",
    finish: "Lamitex Laminate",
    layout: "U-shaped kitchen",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/o25vjwv8_IMG_6656%20%281%29.jpg",
    alt: "Vertex kitchen finished in premium Lamitex laminate",
    description: "Vertex is precision made practical — premium Lamitex laminate fronts with a rich, consistent finish that resists scratches, stains and everyday wear. The layered surface keeps its colour true for years, bringing crisp lines and effortless maintenance to a hard-working kitchen.",
    materials: ["Lamitex laminate shutter fronts", "Scratch- and stain-resistant surface", "E1-grade, low-emission board core", "Precision edge-banded panels"],
  },
  {
    slug: "duetto",
    index: "05",
    name: "Duetto",
    finish: "Solid Wood + PU",
    layout: "Classic framed kitchen",
    image: "/duetto.jpg",
    alt: "Duetto kitchen pairing ivory PU upper cabinets with walnut solid wood base cabinetry",
    description: "Duetto is a kitchen in two voices — ivory PU uppers with glass-fronted display, light and lyrical above; deep walnut solid wood below, grounded and generous with brass at every touch. Crown moulding, framed shutters and a marble splash complete a composition that feels inherited rather than installed.",
    materials: ["Ivory PU upper shutters, framed profile", "Solid walnut base cabinetry", "Brass knobs and cup handles", "Crown moulding and marble-look splash"],
  },
  {
    slug: "palazzo",
    index: "06",
    name: "Palazzo",
    finish: "PU + Membrane",
    layout: "Grand parallel kitchen",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/bsh1k11d_IMG_6815.jpg",
    alt: "Palazzo kitchen with ivory membrane framed uppers and espresso PU base cabinets",
    description: "Palazzo is old-world grandeur, engineered — ivory membrane shutters pressed into deep framed panels, seamless to the last edge, rising beneath sculpted crown moulding; below, espresso PU bases with brass cup pulls ground the room like a grand estate kitchen. A patterned artisan splash ties the two worlds into one unforgettable composition.",
    materials: ["Membrane-pressed ivory shutters, framed profile", "Espresso PU base cabinetry, satin sheen", "Brass cup pulls and knobs", "Sculpted hood and crown moulding"],
  },
  {
    slug: "linea-verde",
    index: "07",
    name: "Linea Verde",
    finish: "Lamitex Laminate",
    layout: "Linear gallery kitchen",
    image: "/linea.jpg",
    alt: "Linea Verde kitchen in woodgrain Lamitex laminate with floor-to-ceiling garden glazing",
    description: "Linea Verde draws a single calm line through the home — handleless woodgrain Lamitex fronts with fine shadow gaps, running wall-to-wall beneath a ribbon of glass and garden light. The laminate is pressed for precision and sealed against scratches and steam, so the clean geometry stays untouched by daily life.",
    materials: ["Lamitex laminate fronts, vertical woodgrain", "Handleless profile with shadow gaps", "Scratch- and steam-resistant surface", "Stone-look composite worktop"],
  },
];
